import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class ReglasStockService extends ApiService {
  entityType = EntityType.PLATAFORMA;
  url = 'api/reglas-stock/';
}
